import { Box } from '@material-ui/core';

import { CartForm } from '@/components/modules/Application/components/Cart/DefaultCart/components/CartForm/CartForm';
import { LastCartsSelector } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/components/LastCartsSelector/LastCartsSelector';
import { CartFormSchema } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/schemas/CartFormSchema';
import { FormWrapper } from '@/components/shared/components/FormWrapper';
import { useApplicationContext } from '@/contexts/ApplicationContext/ApplicationContext';
import { useScreen } from '@/hooks/useScreen';

export const CartFormWrapper = () => {
  const { md } = useScreen();
  const {
    state: { showSummary },
  } = useApplicationContext();

  const defaultValues = { items: [] };

  return (
    <FormWrapper formSchema={CartFormSchema} defaultValues={defaultValues}>
      <>
        <Box
          position={'absolute'}
          right={!md || showSummary ? 0 : '50px'}
          top={0}
          style={{ transition: 'right 0.5s ease-in-out' }}
        >
          <LastCartsSelector />
        </Box>
        <CartForm />
      </>
    </FormWrapper>
  );
};
